<div ngbDropdown (openChange)="openChange($event)" container="body">
    
    <div ngbDropdownToggle  id="tag-list" >
        <span *ngFor="let tag of selected" class="label tag-selected kt-badge kt-badge--primary kt-badge--inline kt-badge--pill" [style.background-color]="tag.color">
            {{ tag.name }}
        </span>


        <div class="empty" *ngIf="selected?.length == 0" title="Add Tag">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon id="bound" points="0 0 24 0 24 24 0 24"/>
                    <path d="M3.52270623,14.028695 C2.82576459,13.3275941 2.82576459,12.19529 3.52270623,11.4941891 L11.6127629,3.54050571 C11.9489429,3.20999263 12.401513,3.0247814 12.8729533,3.0247814 L19.3274172,3.0247814 C20.3201611,3.0247814 21.124939,3.82955935 21.124939,4.82230326 L21.124939,11.2583059 C21.124939,11.7406659 20.9310733,12.2027862 20.5869271,12.5407722 L12.5103155,20.4728108 C12.1731575,20.8103442 11.7156477,21 11.2385688,21 C10.7614899,21 10.3039801,20.8103442 9.9668221,20.4728108 L3.52270623,14.028695 Z M16.9307214,9.01652093 C17.9234653,9.01652093 18.7282432,8.21174298 18.7282432,7.21899907 C18.7282432,6.22625516 17.9234653,5.42147721 16.9307214,5.42147721 C15.9379775,5.42147721 15.1331995,6.22625516 15.1331995,7.21899907 C15.1331995,8.21174298 15.9379775,9.01652093 16.9307214,9.01652093 Z" id="Combined-Shape" [style.fill]="color" fill-rule="nonzero" opacity="0.7"/>
                </g>
            </svg>            
            
            <span>Tags</span>
        </div>   

        <button *ngIf="selected?.length > 0" class="btn btn-light btn-icon add-icon" type="button">
            <span>
                <svg class="kt-svg-icon zero" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" >
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect id="bound" x="0" y="0" width="24" height="24"/>
                        <circle id="Oval-5"  [style.fill]="color"  opacity="0.3" cx="12" cy="12" r="10"/>
                        <path d="M11,11 L11,7 C11,6.44771525 11.4477153,6 12,6 C12.5522847,6 13,6.44771525 13,7 L13,11 L17,11 C17.5522847,11 18,11.4477153 18,12 C18,12.5522847 17.5522847,13 17,13 L13,13 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,13 L7,13 C6.44771525,13 6,12.5522847 6,12 C6,11.4477153 6.44771525,11 7,11 L11,11 Z" id="Combined-Shape"  [style.fill]="color"  />
                    </g>
                </svg>
            </span>
        </button>

    </div>
                 
    
    <div ngbDropdownMenu aria-labelledby="tag-list" class="tag-list">
        <form [formGroup]="checkboxGroup">
            <div class="tag" *ngFor="let tag of tags">
                <label class="kt-checkbox kt-checkbox--solid">
                    <i class="kt-badge kt-badge--danger kt-badge--dot kt-badge--xl" [style.background-color]="tag.color" ></i>
    
                    <input type="checkbox" name="myValues" formArrayName="myValues"  [value]="tag.id" 
                        (change)="onCheckboxChange($event)"
                        [checked]="is_selected(tag.id)" /> {{tag.name}}
                    <span></span>
                </label>
            </div>
        </form>
        <p *ngIf="debug">{{ checkboxGroup.value | json }}</p>
    </div>   
</div>